import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

/**
 * Badge element with various theme types. By default, auto-hide itself if the badge count is 0.
 *
 * Theme is not applied when count is zero.
 *
 * @prop count - Badge value ( number )
 * @prop theme - Badge color (options: primary, secondary, success, danger, warning, info)
 * @prop showZero - Do not hide badge if count is 0 ( boolean, default: false, optional )
 */
export default class Badge extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    count: { type: Number, reflect: true },
    theme: { type: String, reflect: true },
    showZero: { type: Boolean },
  };

  constructor() {
    super();
    this.theme = 'secondary';
  }

  willUpdate() {
    this.hidden = !this.showZero && this.count === 0;
  }

  render() {
    if (this.hidden) {
      return null;
    }

    return html`${this.count}`;
  }
}

customElements.get('ef-badge') || customElements.define('ef-badge', Badge);
